import { gsap } from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { DotLottie } from '@lottiefiles/dotlottie-web';
import Choices from 'choices.js';
import "choices.js/public/assets/styles/choices.css";

gsap.registerPlugin(ScrambleTextPlugin);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
import Lenis from 'lenis';

// Swiper
import { initQuotesSwiper, icitSwiperLoopFix } from './swiper.js';

// Alpine
import './alpine.js';

// Lottie
import { initLottieAnimations } from './lottie.js';

// Magnetic
import './magnetic.js';

// Grow
import { initGrowVisual, initHeaderGrowVisual } from './grow';

// Choices
import { initChoices } from './choices';

// Scramble
import { initScrambleText, initScrambleHeader, initLinesReveal, runLinesReveal } from './scramble';

// Navigation
import { icitNavigation, icitToggleSubmenu } from './navigation';

// Stack slider
import { icitInitStackSlider } from './logos';

// Panels
import { icitFadingPanels } from './panels';

// Filter
import { icitStickyFilter } from './filter';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		// Navigation
		icitNavigation();

		// Grow visual content
		initGrowVisual();

		// Init snappy panels
		icitFadingPanels();

		initHeaderGrowVisual();

		initLottieAnimations();

		// initChoices();

	},
	{ passive: true }
);

document.fonts.ready.then(() => {
	// Scramble text and lines reveal.
	initScrambleHeader();
	initScrambleText();
	initLinesReveal();
});

window.addEventListener(
	'load',
	() => {

		// Initialize Lenis
		const lenis = new Lenis({
			autoRaf: false,
			anchors: {
				duration: 2,
				offset: -140,
			},
		});

		gsap.ticker.add((time) => {
    		lenis.raf(time * 1000); // Lenis wants time in milliseconds
		});

		ScrollTrigger.scrollerProxy(document.body, {
			scrollTop(value) {
				if (arguments.length) {
					lenis.scrollTo(value, { duration: 0, immediate: true }); // On set, scroll instantly
				}
				return lenis.scroll; // On get, return Lenis's current scroll position
			},
			getBoundingClientRect() {
				return {
					top: 0,
					left: 0,
					width: window.innerWidth,
					height: window.innerHeight
				};
			},
		});

		lenis.on('scroll', ScrollTrigger.update);

		ScrollTrigger.refresh();
		lenis.resize();

		window.lenis = lenis;


	}
);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
window.runLinesReveal = runLinesReveal;
window.initQuotesSwiper = initQuotesSwiper;
window.icitToggleSubmenu = icitToggleSubmenu;
window.icitInitStackSlider = icitInitStackSlider;
window.icitSwiperLoopFix = icitSwiperLoopFix;
window.icitStickyFilter = icitStickyFilter;
window.DotLottie = DotLottie;
window.Choices = Choices;